import { render, staticRenderFns } from "./VerificationTable.vue?vue&type=template&id=f78dacb2&scoped=true"
import script from "./VerificationTable.vue?vue&type=script&lang=js"
export * from "./VerificationTable.vue?vue&type=script&lang=js"
import style0 from "./VerificationTable.vue?vue&type=style&index=0&id=f78dacb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78dacb2",
  null
  
)

export default component.exports